<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Sale Import Tax</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" data-toggle="modal" data-target="#modalPurchasingImportTax" data-backdrop="static" data-keyboard="false">
                              <i class="fa fa-upload" aria-hidden="true"></i> Import
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary" @click="processImport">Process</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-list">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                    <th>
                                      <label class="form-checkbox"><input type="checkbox" v-model="selectAll" @click="select"><i class="form-icon"></i></label>
                                    </th>
                                    <th>Sale No.</th>
                                    <th>Date</th>
                                    <th>Faktur No.</th>
                                    <th>Faktur Date</th>
                                    <th>Faktur Process Date</th>
                                    <th>Customer</th>
                                    <th>Subtotal</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="i in filterData" :key="i.id">
                                        <td>
                                            <label class="form-checkbox"><input type="checkbox" :value="i.id" v-model="selected"><i class="form-icon"></i></label>
                                        </td>
                                        <td>{{ i.sale_no }}</td>
                                        <td>{{ i.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ i.faktur_no }}</td>
                                        <td>{{ i.faktur_date }}</td>
                                        <td>{{ i.faktur_process_date }}</td>
                                        <td>{{ i.customer }}</td>
                                        <td>{{ i.subtotal | currency }}</td>
                                        <td>{{ i.discount | currency }}</td>
                                        <td>{{ i.tax | currency }}</td>
                                        <td>{{ i.total | currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PurchasingImportModal @getUploadFile="uploadFile"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import PurchasingImportModal from '@/components/purchasing/PurchasingImportModal.vue'
import { import2Url, getHeader, salesUrl } from '../../config'

export default {
  name: 'SaleImportTax',
  props: ['scroll'],
  components: {
    Loading,
    PurchasingImportModal
  },
  data () {
    var date = new Date()
    return {
      selectAll: false,
      area: '',
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async processImport () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var message = null
      for (let i = 0; i < array.length; i++) {
        var data = this.dataRaw.find(d => d.id === array[i])
        var url = salesUrl + '/set-faktur'
        await axios.post(url, data, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.finish()
            this.loader.isLoading = false
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Import Tax', message, 'success')
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async uploadFile (value) {
      const formData = new FormData()
      formData.append('file', value)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      var url = import2Url + '/sale-tax'
      await axios.post(url, formData, { headers: newObj })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.select()
      this.selectAll = true
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
